import { render } from "./LogsError.vue?vue&type=template&id=2bf07c7b"
import script from "./LogsError.vue?vue&type=script&lang=ts"
export * from "./LogsError.vue?vue&type=script&lang=ts"
script.render = render

export default script